import { peopleSection } from '../content/site';
import { Check } from './Icons';
import { Reveal } from './Reveal';
import './People.css';

export function People() {
  return (
    <section className="section section--ink" id="people">
      <div className="container">
        <Reveal>
          <div className="section-head section-head--wide">
            <p className="eyebrow">{peopleSection.eyebrow}</p>
            <h2 className="section-title">{peopleSection.title}</h2>
            <p className="section-lead">{peopleSection.lead}</p>
          </div>
        </Reveal>

        <div className="people__grid">
          {peopleSection.columns.map((column, index) => (
            <Reveal key={column.title} delay={index * 90}>
              <article className="people__card">
                <header className="people__header">
                  <h3 className="people__title">{column.title}</h3>
                  <p className="people__intro">{column.intro}</p>
                </header>
                <ul className="people__list">
                  {column.points.map((point) => (
                    <li key={point} className="people__item">
                      <Check className="people__check" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
